import styled from 'styled-components'

const SidebarSectionLabel = styled.h3`
  margin: 0;
  padding: ${props => props.theme.spacing.base300} 0;
  margin-bottom: ${props => props.theme.spacing.base300};
  border-bottom: 2px solid ${props => props.theme.colors.separator};
`

export default SidebarSectionLabel
